import { ROLE_TYPES } from "./constants";

export const setUserDataOnLocalStorage = async (userDetails) => {
    localStorage.setItem("userData", JSON.stringify(userDetails));
};

export const getLocalUserInfo = () => {
    const userData = localStorage.getItem("userData");
    const userDetails = userData ? JSON.parse(userData) : false;
    if (userDetails) {
        const permissions = [
            ...userDetails?.role_permissions,
            ...userDetails?.special_permissions,
        ];
        const userInfo = userDetails?.user;
        userInfo.permissions = permissions;
        //userInfo.config = userDetails?.config;
        //userInfo.metadata = userDetails?.metadata;
        return userInfo;
    }
    return {};
};

export const isCounterDashboard = () => {
    const { role_type } = getLocalUserInfo();
    return [
        ROLE_TYPES.COMPANY_COUNTER,
        ROLE_TYPES.COMPANY_CALL_CENTRE_MANAGER,
    ].includes(role_type);
};

export const allowedCounterPanel = () => {
    const { role_type } = getLocalUserInfo();
    return [ROLE_TYPES.COMPANY_CALL_CENTRE_MANAGER].includes(role_type);
};

export function isAllowUserPermission(key, defaultValue = null) {
    if (allowedCounterPanel()) {
        return defaultValue; //always default value privileged value
    }
    const { metadata } = getLocalUserInfo();
    return isCounterUser() && metadata?.[key] !== undefined
        ? metadata?.[key]
        : defaultValue;
}

export const isPrepaidCounterUser = () => {
    const { role_type, config } = getLocalUserInfo();
    return role_type === ROLE_TYPES.COMPANY_COUNTER && config?.is_prepaid;
};

export const isCounterUser = () => {
    const { role_type } = getLocalUserInfo();
    return role_type === ROLE_TYPES.COMPANY_COUNTER;
};

export const getUserMeta = () => {
    const { metadata } = getLocalUserInfo();
    return metadata;
};

export const isCompanyAdmin = () => {
    const { role_type } = getLocalUserInfo();
    return role_type === ROLE_TYPES.COMPANY_ADMIN;
};
export const isSuperAdmin = () => {
    const { role_type } = getLocalUserInfo();
    return role_type === ROLE_TYPES.SUPER_ADMIN;
};
export const isGdsAdmin = () => {
    const { role_type } = getLocalUserInfo();
    return role_type === ROLE_TYPES.GDS_ADMIN;
};

export const isGdsOrSuperAdmin = () => {
    return isSuperAdmin() || isGdsAdmin();
};

export const getAuthUserId = () => {
    const { id } = getLocalUserInfo();
    return id;
};
